//
import Service from '@/services/api/service'
import PchPurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'
import PurchaseOrderStateModel from '@/models/Purchase/PchPurchaseOrderState'
import DetailPurchaseOrderService from '@/services/api/purchase/PchDetailPurchaseOrder'

/**
 * This class describes a pch purchase order.
 *
 * @class      SlTaxDocument (name)
 */
export default class PchPurchaseOrder extends Service {

  /**
   * { function_description }
   *
   * @return     {Array}  { description_of_the_return_value }
   */
  static fields() {
    return [
      { 
        name: 'id',
        type: 'text-field',
        props: {
          label: 'N°',
        },
      },
      {
        name: 'pch_provider_business_name',
        type: 'text-field',
        props: {
          label: 'Proveedor',
        },
      },
      {
        name: 'pch_provider_branch_offices_address',
        type: 'text-field',
        props: {
            label: 'Sucursal',
        },
      },
      {
        name: 'pch_order_state_name',
        type: 'text-field',
        props: {
            label: 'Estado',
        },
      },
      {
        name: 'wh_warehouse_name',
        type: 'text-field',
        props: {
            label: 'Bodega',
        },
      },
      {
        name: 'originator_user_name',
        type: 'text-field',
        props: {
          label: 'Creada por',
        },
      },
      {
        name: 'authorizer_user_name',
        type: 'text-field',
        props: {
          label: 'Autorizado por',
        },
      },
      {
        name: 'authorization_date',
        type: 'date-field',
        props: {
          label: 'Fecha autorización',
        },
      },
      {
        name: 'pch_detail_purchase_orders',
        type: 'table-field',
        flex: {
          class: 'xs12 d-grid',
        },
        props: {
          toolbarTitle: 'Detalle de productos de orden de compra',
          headers: DetailPurchaseOrderService.headers(),
        },
      },
      {
        name: 'iva',
        type: 'currency-field',
        props: {
          label: 'IVA',
          reverse: true
        },
      },
      {
        name: 'net_subtotal',
        type: 'currency-field',
        props: {
          label: 'Neto',
          reverse: true
        },
      },
      {
        name: 'total',
        type: 'currency-field',
        props: {
          label: 'Total',
          reverse: true
        },
      },
    ]
  }

  /**
   * { function_description }
   *
   * @return     {Array}  { description_of_the_return_value }
   */
  static filters() {
    return [
      { 
        name: 'id',
        type: 'text-field',
        props: {
          label: 'N° factura',
        },
      },
      {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        props: {
          itemText: 'business_name',
          itemValue: 'id',
          label: 'Proveedor',
          model: ProviderModel,
          noObject: true,
          paramSearch: 'search',
        },
      },
      {
        name: 'pch_payment_condition_id',
        type: 'autocomplete-model',
        props: {
          itemText: 'type',
          itemValue: 'id',
          label: 'Condición de pago',
          model: PaymentConditionModel,
          noObject: true,
          paramSearch: 'type',
        },
      },
      {
        name: 'pch_purchase_order_state_id',
        type: 'autocomplete-model',
        props: {
          itemText: 'state',
          itemValue: 'id',
          label: 'Estado',
          model: PurchaseOrderStateModel,
          noObject: true,
          paramSearch: 'state',
        },
      },
    ]
  }

  /**
   * { function_description }
   *
   * @return     {Array}  { description_of_the_return_value }
   */
  static headers() {
    return [
      {
        text: '#',
        width: '5%',
        value: 'id',
      },
      {
        text: 'facturas',
        width: '5%',
        value: ({ invoice_number }) => invoice_number ? invoice_number : '-',
      },
      {
        text: 'proveedor',
        value: ({ pch_provider }) => pch_provider.business_name,
      },
      {
        text: 'Creado',
        align: 'center',
        value: ({ created_at }) => created_at ? created_at.substr( 0, 10 ).split( '-' ).reverse().join( '-' ) : '-',
      },
      {
        text: 'Autorizado',
        align: 'center',
        value: ({ authorization_date }) => authorization_date ? authorization_date.substr( 0, 10 ).split( '-' ).reverse().join( '-' ) : '-',
      },
      {
        text: 'Estado',
        align: 'center',
        value: ({ pch_purchase_order_state }) => pch_purchase_order_state.state,
      },
      {
        text: 'neto',
        align: 'center',
        format: 'currency',
        value: 'net_subtotal',
      },
      {
        text: 'iva',
        align: 'center',
        format: 'currency',
        value: 'iva',
      },
      {
        text: 'total',
        align: 'center',
        format: 'currency',
        value: 'total',
      },
    ]
  }
  
  /**
   * The pch purchase order includes
   */
  static includes = [
    'g_authorizer_user.hr_employee',
    'g_originator_user.hr_employee',
    'pch_payment_condition',
    'pch_detail_purchase_orders.wh_product',
    'pch_provider',
    'pch_provider_branch_offices',
    'pch_purchase_order_has_invoice_numbers.pch_purchase_invoice',
    'pch_purchase_order_state',
    'wh_orderers.pch_provider',
    'wh_orderers.pch_provider_branch_offices',
    'wh_orderers.g_supervisor_user',
    'wh_warehouse.g_branch_office.g_commune',
    'wh_warehouse_reception.g_branch_office.g_commune',
  ]

  /**
   * The pch purchase order model
   */
  static model = PchPurchaseOrderModel
}
